import styles from '../../assets/styles/TagBanner/TagBanner.module.scss';
import { motion } from 'framer-motion';
import MimaButton from '../Button/MimaButton';
import React, { useState } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import MimaText from '../MimaText';
import cancel_btn2 from '../../assets/img/cancel_btn (2).svg';
import bell2 from '../../assets/img/bell (2).svg';
import { businessStore, transactionStore } from '../../stores';
import { useNavigate } from 'react-router';
import constant from '../../utils/constant';
import { Link } from 'react-router-dom';

const TagBanner = ({
	children,
	closeModal,
	goBack,
	setShowTagBanner,
	showTagBanner,
	...props
}) => {
	const navigate = useNavigate();
	return (
		<RemoveScroll>
			<motion.div
				initial={{
					opacity: 0,
				}}
				animate={{
					opacity: 1,
					transition: {
						duration: 0.2,
					},
				}}
				exit={{
					opacity: 0,
					transition: {
						duration: 0.2,
					},
				}}
				className={styles.background}>
				<div onClick={closeModal}></div>
				<motion.div
					initial={{
						y: 38,
						x: 100,
					}}
					animate={{
						x: 0,
						transition: {
							duration: 0.2,
						},
					}}
					exit={{
						y: 38,
						x: 100,
						transition: {
							duration: 0.2,
						},
					}}
					className={styles.container}>
					<div className={styles.container__top}>
						<div className={styles.container__close}>
							<img
								src={cancel_btn2}
								alt="Cancel"
								onClick={() => {
									setShowTagBanner(false);
								}}
							/>
						</div>
					</div>
					<div className={styles.content_bell}>
						<img
							src={bell2}
							alt="notification bell"
							className={styles.content_bell__img}
						/>
					</div>
					<div className={styles.content}>
						<div>
							<MimaText variant="subtitleBold" align="center" mb={4} mt={4}>
								Untagged Transactions
							</MimaText>
							<MimaText variant="bodyBold" align="center">
								Hello {businessStore.business?.tradingName}, you have some
								untagged transactions. Kindly click “Tag” to tag your
								transactions.
							</MimaText>
						</div>
						<hr className={styles.content_line} />
						<div className={styles.content_btn}>
							<MimaButton
								title="Tag Now"
								variant="outlined3"
								onClick={() => {
									navigate(constant.Routes.Transactions);
									transactionStore.setTagQuery(true);
								}}
								titleColor="var(--color-primary)"
							/>

							<MimaButton
								title="Not Now"
								variant="outlined3"
								onClick={() => {
									setShowTagBanner(false);
								}}
							/>
						</div>
					</div>
				</motion.div>
			</motion.div>
		</RemoveScroll>
	);
};
export default TagBanner;
